import OrderRecap from './order-recap';

export default OrderRecap;